import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  otp: "",
};

export const otpSlice = createSlice({
  name: "opt",
  initialState,
  reducers: {
    updateOtp(state, action) {
      state.otp = action.payload.otp;
    },
  },
});
export const otpActions = otpSlice.actions;
export default otpSlice.reducer;
